import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { storage } from '../../config';
import { setNaicsCode, setNaicsCodeError, loadingNaicsCode } from '../../store/actions';
import { getBusinessesByNaicsCode } from '../../ajax/endpoints';
import { ViewerPrimaryColorUserStyle } from '../UserCustomization';

import './NaicsMenu.css';
import MenuCloseButton from './MenuCloseButton';

export class NaicsMenuComponent extends Component {

  constructor(props) {
    super(props);
    this.state = { code: this.props.activeNaicsCode || '' };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  handleChange(event) {
    let { value } = event.target;
    if (value.length > 6) {
      value = value.substring(value.length - 6);
    }

    this.setState({ code: value });
  }

  handleSubmit(event) {
    event.preventDefault();

    const {
      type,
      viewerPolygon,
      viewport,
      onCloseClick,
      setNaicsCategory,
      setNaicsError,
    } = this.props;

    if (this.state.code.length >= 2) {
      this.setState({
        code: this.state.code,
        error: null,
      });
      setNaicsCategory(type, this.state.code, viewerPolygon, viewport, onCloseClick);
    } else {
      setNaicsError(type, this.state.code, { error: 'NAICS code length must be between 2 and 6 numbers.' });
    }
  }

  resetForm() {
    this.setState({
      code: '',
      error: null,
    });
    this.props.setNaicsError(this.props.type, this.state.code, { error: null });
  }

  render() {
    const {
      offsetLeft,
      onCloseClick,
      naicsLoading,
      naicsError,
    } = this.props;

    return (
      <div className="map-toolbar__menu map-toolbar--demographics" style={{ left: offsetLeft }}>
        <MenuCloseButton onCloseClick={onCloseClick} />
        <div className="toolbox-content filter-box">
          <div className="naics-search form-group">
            <h4>Enter NAICS Code:</h4>
            <input
              type="number"
              placeholder="0"
              className={
                naicsError ? 'form-control naics-input naics-error' : 'form-control naics-input'
              }
              min="0"
              max="999999"
              value={this.state.code}
              onChange={this.handleChange}
            />
            { naicsError && <div className="naics-error-msg">{naicsError}</div> }
            <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
              <a className={naicsLoading ? 'naics-search button disable-link' : 'naics-search button'} type="button" onClick={this.handleSubmit} tabIndex={0}>Search</a>
            </ViewerPrimaryColorUserStyle>
            <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
              <a className={naicsLoading ? 'naics-search button disable-link' : 'naics-search button'} type="button" onClick={this.resetForm} tabIndex={0}>Reset</a>
            </ViewerPrimaryColorUserStyle>
            <div className="naics-link">
              <a
                href="https://www.naics.com/code-search/"
                target="_blank"
                rel="noopener noreferrer"
                className="naics-link"
              >
                Click here for list of NAICS codes
              </a>
            </div>

            {naicsLoading && (
              <div className="naics-loading">
                <img
                  alt="loading gif"
                  src={`${storage.distPath}/loading.gif`}
                />
              </div>
            )}

          </div>
        </div>
      </div>
    );
  }
}

NaicsMenuComponent.propTypes = {
  type: PropTypes.string.isRequired,
  activeNaicsCode: PropTypes.string,
  offsetLeft: PropTypes.number,
  onCloseClick: PropTypes.func.isRequired,
  viewerPolygon: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.object)]),
  viewport: PropTypes.object,
  naicsLoading: PropTypes.bool,
  naicsError: PropTypes.string,
  setNaicsCategory: PropTypes.func,
  setNaicsError: PropTypes.func,
};

/* istanbul ignore next */
export const mapStateToProps = (state, ownProps) => ({
  code: state.code,
  viewerPolygon: state.viewer.polygon,
  viewport: state.viewportInfo,
  activeNaicsCode: (state[ownProps.type].businesses || {}).naicsCode,
  naicsError: (state[ownProps.type].businesses || {}).error,
  naicsLoading: (state[ownProps.type].businesses || {}).loading || false,
});

/* istanbul ignore next */
export const mapDispatchToProps = dispatch => ({
  setNaicsCategory: (type, naicsCode, polygon, viewport, onCloseClick) => {
    if (!naicsCode) {
      dispatch(setNaicsCode(type, null, null));
      return;
    }

    dispatch(loadingNaicsCode(type, naicsCode));
    getBusinessesByNaicsCode(polygon, naicsCode, viewport)
      .then(businesses => {
        if (businesses.error) {
          dispatch(setNaicsCodeError(type, naicsCode, businesses));
          return;
        }

        dispatch(setNaicsCode(type, naicsCode, businesses));
        onCloseClick();
      });
  },
  setNaicsError: (type, naicsCode, error) => {
    dispatch(setNaicsCodeError(type, naicsCode, error));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NaicsMenuComponent);



// WEBPACK FOOTER //
// ./src/components/MapToolbar/NaicsMenu.js